import { ExperimentFlags } from "@shared/utils.experimentation";
import { useEffect, useState } from "react";
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed";

import { useFeatureFlag } from "hooks";
import { useFavourites } from "packages/membership/pages/Favourites/hooks/useFavourites";
import { OrderItAgain } from "../OrderItAgain";
import { QuizInsert } from "../QuizInsert";

export const DefaultComponentOnSearch = () => {
  const { reorderProducts } = useFavourites({
    currentPage: 1,
    type: "order_it_again"
  });

  const [hasOrderItAgain, setHasOrderItAgain] = useState(false);

  const [isLoading, showOiaOnSearch] = useFeatureFlag(
    ExperimentFlags.SHOW_OIA_ON_SEARCH,
    "0"
  );

  useEffect(() => {
    setHasOrderItAgain(reorderProducts.products?.length > 0);
  }, [reorderProducts]);

  const shouldShowOia =
    !isLoading && showOiaOnSearch === "1" && hasOrderItAgain;

  const trackExperimentViewed = useExperimentViewed();

  useEffect(() => {
    if (!hasOrderItAgain) return;

    trackExperimentViewed(
      ExperimentFlags.SHOW_OIA_ON_SEARCH,
      showOiaOnSearch === "1" ? 1 : 0
    );
  }, [trackExperimentViewed, hasOrderItAgain, showOiaOnSearch]);

  return shouldShowOia ? <OrderItAgain /> : <QuizInsert />;
};
